import { createContext, useContext } from 'react';
import api from '../../../services/api';

// The payment form talks to the server through whatever `usePaymentApi()` returns. Signed-in
// students get the regular authenticated `api`. A new student (not signed in) gets a guest
// adapter with the same method names and response shapes (see guestPaymentApi.js), supplied
// by GuestPayment through this context, so the form itself is the one form for everyone.
export const GuestPaymentContext = createContext(null);

export const usePaymentApi = () => {
  const guest = useContext(GuestPaymentContext);
  return guest ? guest.api : api;
};

// null for signed-in students.
export const useGuestPayment = () => useContext(GuestPaymentContext);
